import React, { useCallback, useMemo } from "react"
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import useIsMobile from "helpers/hooks/useIsMobile";
import { useTheme } from "@mui/material";
import { useTranslations } from "@fenetech/translations";
import { IDashboardQuote } from "models/IDashboardQuote";
import useDashboardCompanyQuoteData from "./useDashboardCompanyQuoteData";
import useCurrencyFormatter from "helpers/hooks/useCurrencyFormatter";
import useUserInfo from "helpers/context/User/useUserInfo";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

const CompanyQuotesGrid: React.FC = () => {

    const tm = useTranslations();
    const cf = useCurrencyFormatter();
    const theme = useTheme();
    const data: IDashboardQuote[]|undefined = useDashboardCompanyQuoteData();
    const isMobile = useIsMobile();
    const user = useUserInfo();

    const getRowId: GridRowIdGetter = useCallback((row: GridRowModel) => {
        return row.oKey;
    }, []);

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, data, theme, isMobile, cf);
    
        generator.TryAddDocumentNumberColumn("oKey", "orderNumber", "Quote", "/quotes", { hideable: false });
        generator.TryAddTextColumn("salespersonName", "Salesperson", {});
        generator.TryAddWebCustomerColumn("webCenterCustomerName", "customerInactive", "Customer", {});
        generator.TryAddDateColumn("orderDate", "Date", {});
        generator.TryAddTextColumn("shippingName", "Shipping Name", {});
        generator.TryAddTextColumn("billingName", "Billing Name", {});
        generator.TryAddTextColumn("poNumber", "PO Number", {});
        generator.TryAddTextColumn("customerRef", "Customer Ref", {});
        generator.TryAddTotalPriceColumn({});
        generator.TryAddTotalPriceColumn({}, "totalCost", "Cost");
        generator.TryAddDateColumn("expirationDate", "Expires", {});
        if (user.isMultiSite) {
            generator.TryAddTextColumn("mfgSiteName", "Mfg Customer", {});
        }

        return generator.GetColumns();
    }, [tm, data, theme, isMobile, cf, user]);

    return <CustomDataGridPro
        rows={data}
        columns={columns}
        getRowId={getRowId}
        tableName="DashboardCompanyQuote"
        tableSubName={isMobile ? "Mobile" : ""}
        hideByDefaultColumns={[
            "billingName"
        ]}
        hideInMobileColumns={[
            "orderDate",
            "poNumber",
            "expirationDate",
            "mfgSiteName",
            "shippingName",
            "salespersonName",
            "totalCost"
        ]}
    />

};

export default CompanyQuotesGrid;